function BasicDetails({
    name,
    setName,
    price,
    setPrice,
    stock,
    setStock,
    description,
    setDescription,
    imageFile,
    setImageFile,
    categoryId,
    setCategoryId,
    categories,
    fetchBrands,
    fetchTypes,
    brandId,
    setBrandId,
    brands,
    typeId,
    setTypeId,
    types,
    fetchFeatures,
    setFeatures,
    setFeatureValues
}) {

    return (

        <div className="card shadow-sm border-0">

            <div className="card-header bg-dark text-white">

                <h5 className="mb-0">

                    Basic Details

                </h5>

            </div>

            <div className="card-body">

                <div className="mb-3">

                    <label className="form-label">

                        Product Name

                    </label>

                    <input
                        className="form-control"
                        value={name}
                        onChange={(e)=>setName(e.target.value)}
                    />

                </div>


                <div className="row">

                    <div className="col-md-6 mb-3">

                        <label className="form-label">

                            Price

                        </label>

                        <input
                            type="number"
                            className="form-control"
                            value={price}
                            onChange={(e)=>setPrice(e.target.value)}
                        />

                    </div>

                    <div className="col-md-6 mb-3">

                        <label className="form-label">

                            Stock

                        </label>

                        <input
                            type="number"
                            className="form-control"
                            value={stock}
                            onChange={(e)=>setStock(e.target.value)}
                        />

                    </div>

                </div>


                <div className="mb-3">

                    <label className="form-label">

                        Category

                    </label>

                    <select
                        className="form-select"
                        value={categoryId}
                        onChange={(e)=>{

                            const id=e.target.value;

                            setCategoryId(id);

                            setBrandId("");

                            setTypeId("");

                            setFeatureValues({});

                            setFeatures([]);

                            fetchBrands(id);

                            fetchTypes(id);

                        }}
                    >

                        <option value="">

                            Select Category

                        </option>

                        {

                            categories.map(category=>(

                                <option
                                    key={category.id}
                                    value={category.id}
                                >

                                    {category.name}

                                </option>

                            ))

                        }

                    </select>

                </div>


                <div className="mb-3">

                    <label className="form-label">

                        Product Type

                    </label>

                    <select
                        className="form-select"
                        value={typeId}
                        disabled={!categoryId}
                        onChange={(e)=>{

                            const id=e.target.value;

                            setTypeId(id);

                            setFeatureValues({});

                            fetchFeatures(id);

                        }}
                    >

                        <option value="">

                            Select Product Type

                        </option>

                        {

                            types.map(type=>(

                                <option
                                    key={type.id}
                                    value={type.id}
                                >

                                    {type.name}

                                </option>

                            ))

                        }

                    </select>

                </div>


                <div className="mb-3">

                    <label className="form-label">

                        Brand

                    </label>

                    <select
                        className="form-select"
                        value={brandId}
                        disabled={!categoryId}
                        onChange={(e)=>setBrandId(e.target.value)}
                    >

                        <option value="">

                            Select Brand

                        </option>

                        {

                            brands.map(brand=>(

                                <option
                                    key={brand.id}
                                    value={brand.id}
                                >

                                    {brand.name}

                                </option>

                            ))

                        }

                    </select>

                </div>

                <div className="mb-3">

                    <label className="form-label">

                        Description

                    </label>

                    <textarea
                        rows="6"
                        className="form-control"
                        value={description}
                        onChange={(e)=>setDescription(e.target.value)}
                    />

                </div>


                <div>

                    <label className="form-label">

                        Product Image

                    </label>

                    <input
                        type="file"
                        className="form-control"
                        onChange={(e)=>setImageFile(e.target.files[0])}
                    />

                    {

                        imageFile && (

                            <img
                                src={URL.createObjectURL(imageFile)}
                                alt=""
                                className="img-fluid rounded mt-3"
                                style={{
                                    maxHeight:"220px",
                                    objectFit:"contain"
                                }}
                            />

                        )

                    }

                </div>

            </div>

        </div>

    );

}

export default BasicDetails;